import { TDropItem } from 'src/types';

export const collegeBoardOfferingsOptions: TDropItem[] = [
    { value: 'preApCourses', label: 'Offer Pre-AP courses' },
    { value: 'administerPsat', label: 'Administering PSAT' },
    { value: 'satTestCenter', label: 'Becoming an SAT test center' },
];
